class $a5fd07fa01589658$export$2e2bcd8739ae039 {
    constructor(initialState){
        this.score = 0;
        this.status = "idle";
        this.isStarted = false;
        this.idSeq = 1;
        this.board = this.makeEmptyBoard();
        if (Array.isArray(initialState)) this.board = this.fromNumberBoard(initialState);
        this.initialBoardState = this.cloneBoard(this.board);
        this.lastTilesSnapshot = [];
    }
    makeEmptyBoard() {
        return Array.from({
            length: 4
        }, ()=>Array.from({
                length: 4
            }, ()=>null));
    }
    cloneBoard(board) {
        return board.map((row)=>row.map((cell)=>cell ? {
                    id: cell.id,
                    value: cell.value
                } : null));
    }
    fromNumberBoard(numBoard) {
        const b = this.makeEmptyBoard();
        for(let r = 0; r < 4; r += 1)for(let c = 0; c < 4; c += 1){
            const v = numBoard?.[r]?.[c] ?? 0;
            if (v && v !== 0) {
                b[r][c] = {
                    id: this.idSeq,
                    value: v
                };
                this.idSeq += 1;
            }
        }
        return b;
    }
    emptyCells(board) {
        const cells = [];
        for(let r = 0; r < 4; r += 1){
            for(let c = 0; c < 4; c += 1)if (!board[r][c]) cells.push({
                r: r,
                c: c
            });
        }
        return cells;
    }
    generateNewTile(board) {
        const empty = this.emptyCells(board);
        if (empty.length === 0) return null;
        const randomIndex = Math.floor(Math.random() * empty.length);
        const { r: r, c: c } = empty[randomIndex];
        const value = Math.random() < 0.1 ? 4 : 2;
        const tile = {
            id: this.idSeq,
            value: value
        };
        this.idSeq += 1;
        board[r][c] = tile;
        return {
            tile: tile,
            row: r,
            col: c
        };
    }
    checkWin() {
        for(let r = 0; r < 4; r += 1)for(let c = 0; c < 4; c += 1){
            const t = this.board[r][c];
            if (t && t.value === 2048) {
                this.status = "win";
                return true;
            }
        }
        return false;
    }
    hasAvailableMoves() {
        for(let r = 0; r < 4; r += 1)for(let c = 0; c < 4; c += 1){
            if (!this.board[r][c]) return true;
        }
        for(let r = 0; r < 4; r += 1)for(let c = 0; c < 4; c += 1){
            const cur = this.board[r][c]?.value;
            if (cur == null) continue;
            if (c < 3 && this.board[r][c + 1]?.value === cur) return true;
            if (r < 3 && this.board[r + 1][c]?.value === cur) return true;
        }
        return false;
    }
    checkGameStatus() {
        if (this.checkWin()) return;
        if (!this.hasAvailableMoves()) this.status = "lose";
    }
    snapshotTiles(board, flagsById = new Map()) {
        const tiles = [];
        for(let r = 0; r < 4; r += 1)for(let c = 0; c < 4; c += 1){
            const t = board[r][c];
            if (!t) continue;
            const flags = flagsById.get(t.id) || {};
            tiles.push({
                id: t.id,
                value: t.value,
                row: r,
                col: c,
                isNew: Boolean(flags.isNew),
                isMerged: Boolean(flags.isMerged)
            });
        }
        this.lastTilesSnapshot = tiles;
    }
    compressAndMergeLine(line) {
        const filtered = line.filter(Boolean);
        const newLine = [];
        let scoreChange = 0;
        let moved = false;
        const mergedIds = new Set();
        let i = 0;
        while(i < filtered.length){
            const cur = filtered[i];
            const next = filtered[i + 1];
            if (next && next.value === cur.value) {
                const mergedTile = {
                    id: cur.id,
                    value: cur.value * 2
                };
                newLine.push(mergedTile);
                scoreChange += mergedTile.value;
                mergedIds.add(mergedTile.id);
                i += 2;
            } else {
                newLine.push({
                    id: cur.id,
                    value: cur.value
                });
                i += 1;
            }
        }
        while(newLine.length < 4)newLine.push(null);
        for(let k = 0; k < 4; k += 1){
            const a = line[k];
            const b = newLine[k];
            const aKey = a ? `${a.id}:${a.value}` : "null";
            const bKey = b ? `${b.id}:${b.value}` : "null";
            if (aKey !== bKey) {
                moved = true;
                break;
            }
        }
        return {
            newLine: newLine,
            scoreChange: scoreChange,
            mergedIds: mergedIds,
            moved: moved
        };
    }
    move(direction) {
        if (this.status !== "playing") return false;
        const old = this.cloneBoard(this.board);
        const next = this.makeEmptyBoard();
        const flagsById = new Map();
        let boardChanged = false;
        let scoreDelta = 0;
        const mergedAll = new Set();
        const take = (r, c)=>old[r][c];
        const writeRow = (r, arr)=>{
            for(let c = 0; c < 4; c += 1)next[r][c] = arr[c];
        };
        const writeCol = (c, arr)=>{
            for(let r = 0; r < 4; r += 1)next[r][c] = arr[r];
        };
        if (direction === "left" || direction === "right") for(let r = 0; r < 4; r += 1){
            let line = [
                take(r, 0),
                take(r, 1),
                take(r, 2),
                take(r, 3)
            ];
            if (direction === "right") line = line.reverse();
            const { newLine: newLine, scoreChange: scoreChange, mergedIds: mergedIds, moved: moved } = this.compressAndMergeLine(line);
            scoreDelta += scoreChange;
            for (const id of mergedIds)mergedAll.add(id);
            if (moved) boardChanged = true;
            const finalLine = direction === "right" ? newLine.reverse() : newLine;
            writeRow(r, finalLine);
        }
        else for(let c = 0; c < 4; c += 1){
            let line = [
                take(0, c),
                take(1, c),
                take(2, c),
                take(3, c)
            ];
            if (direction === "down") line = line.reverse();
            const { newLine: newLine, scoreChange: scoreChange, mergedIds: mergedIds, moved: moved } = this.compressAndMergeLine(line);
            scoreDelta += scoreChange;
            for (const id of mergedIds)mergedAll.add(id);
            if (moved) boardChanged = true;
            const finalLine = direction === "down" ? newLine.reverse() : newLine;
            writeCol(c, finalLine);
        }
        if (!boardChanged) {
            this.snapshotTiles(this.board);
            return false;
        }
        this.score += scoreDelta;
        for (const id of mergedAll)flagsById.set(id, {
            ...flagsById.get(id) || {},
            isMerged: true
        });
        const spawned = this.generateNewTile(next);
        if (spawned) flagsById.set(spawned.tile.id, {
            isNew: true,
            isMerged: false
        });
        this.board = next;
        this.checkGameStatus();
        this.snapshotTiles(this.board, flagsById);
        return true;
    }
    moveLeft() {
        return this.move("left");
    }
    moveRight() {
        return this.move("right");
    }
    moveUp() {
        return this.move("up");
    }
    moveDown() {
        return this.move("down");
    }
    getScore() {
        return this.score;
    }
    getState() {
        return this.board.map((row)=>row.map((cell)=>cell ? cell.value : 0));
    }
    getTiles() {
        if (!this.lastTilesSnapshot || this.lastTilesSnapshot.length === 0) this.snapshotTiles(this.board);
        return this.lastTilesSnapshot;
    }
    getStatus() {
        return this.status;
    }
    start() {
        this.board = this.cloneBoard(this.initialBoardState);
        this.score = 0;
        const flags = new Map();
        const a = this.generateNewTile(this.board);
        const b = this.generateNewTile(this.board);
        if (a) flags.set(a.tile.id, {
            isNew: true
        });
        if (b) flags.set(b.tile.id, {
            isNew: true
        });
        this.status = "playing";
        this.isStarted = true;
        this.snapshotTiles(this.board, flags);
    }
    restart() {
        this.status = "idle";
        this.isStarted = false;
        this.start();
    }
}


const $09e991522ca7e64e$var$game = new (0, $a5fd07fa01589658$export$2e2bcd8739ae039)();
const $09e991522ca7e64e$var$gameField = document.querySelector(".game-field");
const $09e991522ca7e64e$var$tilesLayer = document.querySelector(".tiles");
const $09e991522ca7e64e$var$scoreElement = document.querySelector(".game-score");
const $09e991522ca7e64e$var$startButton = document.querySelector(".button");
const $09e991522ca7e64e$var$messageStart = document.querySelector(".message-start");
const $09e991522ca7e64e$var$messageLose = document.querySelector(".message-lose");
const $09e991522ca7e64e$var$messageWin = document.querySelector(".message-win");
const $09e991522ca7e64e$var$CELL = 75;
const $09e991522ca7e64e$var$GAP = 10;
const $09e991522ca7e64e$var$tileEls = new Map();
function $09e991522ca7e64e$var$hideAllMessages() {
    $09e991522ca7e64e$var$messageStart.classList.add("hidden");
    $09e991522ca7e64e$var$messageLose.classList.add("hidden");
    $09e991522ca7e64e$var$messageWin.classList.add("hidden");
}
function $09e991522ca7e64e$var$pos(row, col) {
    return {
        x: col * ($09e991522ca7e64e$var$CELL + $09e991522ca7e64e$var$GAP) + $09e991522ca7e64e$var$GAP,
        y: row * ($09e991522ca7e64e$var$CELL + $09e991522ca7e64e$var$GAP) + $09e991522ca7e64e$var$GAP
    };
}
function $09e991522ca7e64e$var$createTileEl(tile) {
    const el = document.createElement("div");
    el.className = `tile tile--${tile.value}`;
    el.dataset.id = String(tile.id);
    const inner = document.createElement("div");
    inner.className = "tile__inner";
    inner.textContent = String(tile.value);
    el.appendChild(inner);
    $09e991522ca7e64e$var$tilesLayer.appendChild(el);
    return el;
}
function $09e991522ca7e64e$var$setTilePosition(el, row, col) {
    const { x: x, y: y } = $09e991522ca7e64e$var$pos(row, col);
    el.style.transform = `translate(${x}px, ${y}px)`;
}
function $09e991522ca7e64e$var$updateBoard() {
    const tiles = $09e991522ca7e64e$var$game.getTiles();
    const nextIds = new Set(tiles.map((t)=>t.id));
    for (const [id, el] of $09e991522ca7e64e$var$tileEls)if (!nextIds.has(id)) {
        el.remove();
        $09e991522ca7e64e$var$tileEls.delete(id);
    }
    for (const t of tiles){
        let el = $09e991522ca7e64e$var$tileEls.get(t.id);
        if (!el) {
            el = $09e991522ca7e64e$var$createTileEl(t);
            $09e991522ca7e64e$var$tileEls.set(t.id, el);
            $09e991522ca7e64e$var$setTilePosition(el, t.row, t.col);
            const inner = el.querySelector(".tile__inner");
            if (t.isNew) {
                inner.classList.add("tile__inner--spawn");
                window.setTimeout(()=>inner.classList.remove("tile__inner--spawn"), 180);
            }
        }
        el.className = `tile tile--${t.value}`;
        const inner = el.querySelector(".tile__inner");
        inner.textContent = String(t.value);
        requestAnimationFrame(()=>{
            $09e991522ca7e64e$var$setTilePosition(el, t.row, t.col);
        });
        if (t.isMerged) {
            inner.classList.add("tile__inner--merge");
            window.setTimeout(()=>inner.classList.remove("tile__inner--merge"), 220);
        }
    }
}
function $09e991522ca7e64e$var$updateScore() {
    $09e991522ca7e64e$var$scoreElement.textContent = String($09e991522ca7e64e$var$game.getScore());
}
function $09e991522ca7e64e$var$updateStatus() {
    const st = $09e991522ca7e64e$var$game.getStatus();
    if ($09e991522ca7e64e$var$game.isStarted) {
        $09e991522ca7e64e$var$startButton.textContent = "Restart";
        $09e991522ca7e64e$var$startButton.classList.remove("start");
        $09e991522ca7e64e$var$startButton.classList.add("restart");
    } else {
        $09e991522ca7e64e$var$startButton.textContent = "Start";
        $09e991522ca7e64e$var$startButton.classList.add("start");
        $09e991522ca7e64e$var$startButton.classList.remove("restart");
    }
    $09e991522ca7e64e$var$hideAllMessages();
    if (st === "win") $09e991522ca7e64e$var$messageWin.classList.remove("hidden");
    else if (st === "lose") $09e991522ca7e64e$var$messageLose.classList.remove("hidden");
    else if (st === "idle") $09e991522ca7e64e$var$messageStart.classList.remove("hidden");
}
function $09e991522ca7e64e$var$updateUI() {
    $09e991522ca7e64e$var$updateBoard();
    $09e991522ca7e64e$var$updateScore();
    $09e991522ca7e64e$var$updateStatus();
}
function $09e991522ca7e64e$var$resetUiTiles() {
    for (const [, el] of $09e991522ca7e64e$var$tileEls)el.remove();
    $09e991522ca7e64e$var$tileEls.clear();
}
function $09e991522ca7e64e$var$handleStartClick() {
    if ($09e991522ca7e64e$var$game.getStatus() === "playing" || $09e991522ca7e64e$var$game.isStarted) {
        $09e991522ca7e64e$var$game.restart();
        $09e991522ca7e64e$var$resetUiTiles();
    } else $09e991522ca7e64e$var$game.start();
    $09e991522ca7e64e$var$updateUI();
}
function $09e991522ca7e64e$var$handleKeyDown(e) {
    if ($09e991522ca7e64e$var$game.getStatus() !== "playing") return;
    let moved = false;
    switch(e.key){
        case "ArrowLeft":
            moved = $09e991522ca7e64e$var$game.moveLeft();
            break;
        case "ArrowRight":
            moved = $09e991522ca7e64e$var$game.moveRight();
            break;
        case "ArrowUp":
            moved = $09e991522ca7e64e$var$game.moveUp();
            break;
        case "ArrowDown":
            moved = $09e991522ca7e64e$var$game.moveDown();
            break;
        default:
            return;
    }
    if (moved) {
        e.preventDefault();
        $09e991522ca7e64e$var$updateUI();
    }
}
function $09e991522ca7e64e$var$init() {
    if (!$09e991522ca7e64e$var$startButton || !$09e991522ca7e64e$var$gameField || !$09e991522ca7e64e$var$scoreElement || !$09e991522ca7e64e$var$tilesLayer) return;
    $09e991522ca7e64e$var$startButton.addEventListener("click", $09e991522ca7e64e$var$handleStartClick);
    document.addEventListener("keydown", $09e991522ca7e64e$var$handleKeyDown);
    $09e991522ca7e64e$var$updateUI();
}
$09e991522ca7e64e$var$init();


//# sourceMappingURL=index.c2f54949.js.map
